import {BaseModel} from '../base/BaseModel';

export class AppSettingModel extends BaseModel {

    initialize () {

        this.microservice = 'app-configs';
        this.resource = 'settings';
    }

    get defaults () {

        return {
            uuid: undefined,
            name: undefined,
            value: undefined,
            scope: undefined,
            objectType: undefined,
            objectId: undefined,
            requiresFunctionality: undefined
        };
    }

    static get OBJECT_TYPE () {

        return {
            COUNTRY : 'COUNTRY',
            COUNTRY_CROP : 'COUNTRY_CROP',
            CROP : 'CROP'
        };
    }

    static get SCOPE () {

        return {
            TAMS : 'TAMS'
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/app-configs/AppSettingModel.js